
import {
  defineComponent,
  ref,
  useContext,
  computed,
} from '@nuxtjs/composition-api';
import { breakpoint } from '~/composables/breakpoint';
import useFilter from '~/composables/useFilter';

import CategoryCatalogSidebar from '~/domains/category/components/CategoryCatalogSidebar';
import CategoryCatalogContent from '~/domains/category/components/CategoryCatalogContent';

export default defineComponent({
  name: 'CategoryCatalog',
  components: {
    CategoryCatalogContent,
    CategoryCatalogSidebar,
  },
  props: {
    category: {
      type: Object,
      default: () => {},
    },
    totalPages: {
      type: Number,
      default: null,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const isOpenSidebar = ref(false);
    const { isBiggerThanBreakpoint } = breakpoint('xl');
    const { i18n } = useContext();

    const {
      getQueryParams,
      selectedFilters,
      getQueriesFromURL,
      updateSelectedFilters,
      addQueryToRoute,
      clearFilter,
      addToFilterHistory,
      addFilterHistoryToSelectedFilters,
    } = useFilter();

    const openSidebar = () => {
      isOpenSidebar.value = true;
    };

    const closeSidebar = () => {
      isOpenSidebar.value = false;
    };

    const handleChangeFilters = (payload) => {
      updateSelectedFilters(payload);
      if (isBiggerThanBreakpoint.value) {
        addQueryToRoute();
        emit('fetchCategoryByFilter', getQueryParams.value);
      }
    };

    const handleMobileChangeFilters = () => {
      isOpenSidebar.value = false;
      addQueryToRoute();
      emit('fetchCategoryByFilter', getQueryParams.value);
    };

    const handleClearFilter = () => {
      clearFilter();
      if (isOpenSidebar.value) {
        isOpenSidebar.value = false;
      }

      addQueryToRoute();
      emit('fetchCategoryByFilter', getQueryParams.value);
    };

    const handleCloseSidebar = () => {
      addFilterHistoryToSelectedFilters();
      closeSidebar();
    };

    const handleOpenSidebar = () => {
      addToFilterHistory();
      openSidebar();
    };
    const itemsCount = computed(() => {
      return props.category
        ? `${props.category.products_meta_count} ${
            props.category.products_meta_count <= 1
              ? i18n.tc('item', 0)
              : i18n.tc('item', 1)
          }`
        : 0;
    });

    const preparedFiltersList = computed(() => {
      const { category } = props;
      if (!category) return undefined;

      const { features = [], aggs = [] } = category;
      const filteredList = features
        .concat(aggs)
        .filter(
          (filterItem) => filterItem.buckets && filterItem.buckets.length
        );

      return filteredList.length ? filteredList : undefined;
    });

    const isFiltersVisible = computed(
      () => !!preparedFiltersList.value?.length
    );

    const isSideBar = computed(() =>
      isBiggerThanBreakpoint.value ? isFiltersVisible.value : true
    );

    const gridClasses = computed(() => {
      const screenXlWithFilters = { 'xl:grid-cols-[25%_1fr]': true };
      const screenXlNoFilters = { 'xl:grid-cols-[1fr]': true };
      return isFiltersVisible.value ? screenXlWithFilters : screenXlNoFilters;
    });

    return {
      isBiggerThanBreakpoint,
      getQueriesFromURL,
      getQueryParams,
      selectedFilters,
      isOpenSidebar,
      openSidebar,
      closeSidebar,
      handleChangeFilters,
      handleMobileChangeFilters,
      handleClearFilter,
      handleCloseSidebar,
      handleOpenSidebar,
      itemsCount,
      preparedFiltersList,

      isFiltersVisible,
      gridClasses,
      isSideBar,
    };
  },
});
